











































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ajax from '@/lib/ajax';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { AgencySettingsModule } from '@/store/modules/agencySettings';

@Component({ name: 'OpportunityLocationGeneralDetailsEdit' })
export default class extends GiganautVueDialog {
  selectedLocation: any = null;
  companyLocations: any[] = [];
  loadingCompanyLocations = false;

  entity = {
    prospectLocationName: '',
    prospectLocationEmail: '',
    prospectLocationPhone: '',
    prospectLocationTypeId: null as string | null,
  };

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }
  get locationTypes() { return AgencySettingsModule.locationTypes; }

  async fetchCompanyLocations(companyId: string) {
    this.loadingCompanyLocations = true;
    try {
      const r = await ajax.get(`/api/v1/agency/companies/${companyId}/locations`);
      this.companyLocations = r.data || [];
    } finally {
      this.loadingCompanyLocations = false;
    }
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    const o = this.opportunity;
    this.selectedLocation = o.location || null;
    this.entity.prospectLocationName = o.prospectLocationName;
    this.entity.prospectLocationEmail = o.prospectLocationEmail;
    this.entity.prospectLocationPhone = o.prospectLocationPhone;
    this.entity.prospectLocationTypeId = o.prospectLocationTypeId;
    if (this.locationTypes.length === 0) AgencySettingsModule.getLocationTypes();
    if (o.companyId) this.fetchCompanyLocations(o.companyId);
    else this.companyLocations = [];
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    const opp = this.opportunity;
    const newLocationId = this.selectedLocation ? this.selectedLocation.id : null;

    if (newLocationId !== (opp.locationId || null)) {
      await OpportunityDetailsModule.updateLinks({
        id: opp.id,
        companyId: opp.companyId,
        locationId: newLocationId,
        contactId: opp.contactId,
        updatedAt: opp.updatedAt,
      });
    }
    if (!newLocationId) {
      const refreshed = OpportunityDetailsModule.opportunity!;
      await OpportunityDetailsModule.updateProspectLocationDetails({
        id: opp.id,
        updatedAt: refreshed.updatedAt,
        ...this.entity,
      });
    }
    this.dialog = false;
  }
}
